import '@grandvisionhq/utils';
import { getFrameMeasurements } from '../../utils/get-frame-measurements.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../../types/product.js';

const getSharedFrameVariantProps = ({ frameFeatures , lensFeatures  })=>{
    const { bridgeWidth , color: frameColor , width: frameWidth , size: frameSize , templeLength ,  } = frameFeatures !== null && frameFeatures !== void 0 ? frameFeatures : {};
    const { lensColor , lensHeight , lensWidth  } = lensFeatures !== null && lensFeatures !== void 0 ? lensFeatures : {};
    const frameColorName = Array.isArray(frameColor) ? frameColor.join(' / ') : frameColor;
    const colorFacet = [
        lensColor,
        frameColorName
    ].filter(Boolean).join(' / ');
    const frameMeasurements = getFrameMeasurements(bridgeWidth, frameWidth, lensHeight, lensWidth, templeLength);
    var ref;
    return {
        facets: {
            color: !!colorFacet ? colorFacet : undefined,
            size: (ref = frameSize === null || frameSize === void 0 ? void 0 : frameSize.size) !== null && ref !== void 0 ? ref : undefined
        },
        frameMeasurements
    };
};

export { getSharedFrameVariantProps };
//# sourceMappingURL=get-shared-frame-variant-props.js.map
